import React from "react";

import {UserService} from "../../serverService/userService/UserService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import {
    RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoConfirmDialog, RaikoLabel, RaikoLabelType,
    RaikoSectionContainer,
    RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function UserBanAccess({userId}) {


    const service = new UserService();
    const loading = new LoadingHelper(useLoadingDispatcher());

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUserEnabled()
        }
    }, [userId])

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false)
    const [enabled, setEnabled] = useState(true)

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }


    function getUserEnabled() {
        loading.show()
        service.getUserEnabled(userId).then(
            response => {
                setEnabled(response.enabled)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleChangeEnableSetting() {
        loading.show()

        service.updateUserEnabled(
            userId,
            !enabled
        ).then(response => {

            if (response.enabled)
                showSuccessMessage("دسترسی کاربر با موفقیت فعال شد.")
            else
                showWarningMessage("دسترسی کاربر با موفقیت مسدود شد.")

            setConfirmDialogOpenState(false)
            setEnabled(response.enabled)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"مسدود سازی کاربر"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!enabled ? "رفع مسدود سازی" : "مسدود سازی"}
            />
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت مسدود سازی کاربر"}
                    subTitle={"با فعالسازی این مورد دسترسی کاربر به طور کلی به برنامه قطع خواهد شد."}

                >
                    <RaikoToggleOutlined
                        labelText={"مسدود سازی (مسدود شده / رفع مسدود سازی)"}
                        setChecked={state => {
                            handleOpenConfirmDialog()
                        }}
                        checked={!enabled}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </>
    )
}